import request from './request';
import {
  AgencyInfo,
  Products,
  Apply,
  CarBrands,
  CarModels,
  Payment,
  Business,
} from './API';

export const getAgencyInfo = () => {
  return request.get(AgencyInfo.userInfo);
};

export const getProducts = () => {
  return request.get(Products.getProducts);
};

export const getQuote = (data: any) => {
  return request.post(Apply.applyBshTplMotor, { data });
};

export const getCarBrand = () => {
  return request.get(CarBrands.getCarBrand);
};

export const getCarModel = (data: any) => {
  return request.get(CarModels.getCarModel, { params: data });
};

export const toPay = (data: any) => {
  return request.post(Payment.toPay, { data });
};

export const getEPolicy = (url: any) => {
  let link = url;
  if (link?.includes('?')) {
    const index = url.indexOf('?');
    const cleanUrl = url.substring(0, index);
    const params = url.substring(index);
    link = `${cleanUrl}/origin_url${params}`;
  }
  return request(link?.replace(API_URL, ''), { method: 'get' });
};

export const getImageUrl = (url: any) => {
  let link = url;
  if (link?.includes('?')) {
    const index = url.indexOf('?');
    const cleanUrl = url.substring(0, index);
    const params = url.substring(index);
    link = `${cleanUrl}/origin_url${params}`;
  }
  return request(link?.replace(API_URL, ''), { method: 'get' });
};

export const getPlanCmsDetail = ({
  productType,
  productId,
  planId,
}: {
  productType: string;
  productId: any;
  planId: string;
}) => {
  return request(
    `/v1/shaft/admin/class/ips/vn/${productType}/products/${productId}/plans/cms/${planId}`,
  );
};

export const CreateShare = (
  productType: string,
  productKey: string,
  planKey: string,
  quotationId: string,
) => {
  return request(
    `/v1/shaft/admin/class/ips/vn/${productType}/products/${productKey}/plans/${planKey}/quotation/${quotationId}/share`,
    {
      method: 'post',
    },
  );
};

export const sendEmailOtp = (params: any) => {
  return request.post(`/v1/admin_account/login/email_verification/send_code`, {
    data: params,
  });
};

export const verifyEmailOtp = (params: any) => {
  return request.post(`/v1/admin_account/login/email_verification/check_code`, {
    data: params,
  });
};

export const getStatistics = (data: any) => {
  return request.get(Business.getStatistics, { params: data });
};

export const getDownLines = (data: any) => {
  return request.get(Business.getDownLines, { params: data });
};

export const getTurboDataSourceOptions = (dataSourceKey: string, data: any) => {
  return request.get(
    `/v1/insur_turbo/executor/static/drop_down_options/${dataSourceKey}`,
    { params: data },
  );
};
